// MF-67 — Free geocoding via OpenStreetMap Nominatim (no API key). Turns an address string into an
// approximate { lat, lng } so we can centre the map on the school before dropping the precise pin.
// Light, on-demand use only (Nominatim asks ≤1 req/sec, no bulk) — we call it on a button click.
export const geocodeAddress = async (query) => {
  const q = String(query || '').trim()
  if (!q) return null
  const url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=0&limit=1&q=${encodeURIComponent(
    q
  )}`
  try {
    const res = await fetch(url, { headers: { Accept: 'application/json' } })
    if (!res.ok) return null
    const data = await res.json()
    const hit = Array.isArray(data) ? data[0] : null
    if (hit?.lat && hit?.lon) {
      return { lat: Number(hit.lat), lng: Number(hit.lon), label: hit.display_name }
    }
    return null
  } catch {
    return null
  }
}
